import { Sparkles } from "lucide-react";

const PROVIDER_COLORS: Record<string, string> = {
  OPENAI: 'bg-emerald-500',
  ANTHROPIC: 'bg-orange-500',
  GOOGLE: 'bg-blue-500',
  GEMINI: 'bg-blue-500',
  META: 'bg-blue-600',
  MISTRAL: 'bg-amber-500',
  DEEPSEEK: 'bg-indigo-500',
  XAI: 'bg-neutral-900',
  SBER: 'bg-green-600',
  YANDEX: 'bg-red-500',
};

const PROVIDER_LABELS: Record<string, string> = {
  OPENAI: 'OA',
  ANTHROPIC: 'An',
  GOOGLE: 'G',
  GEMINI: 'G',
  META: 'M',
  MISTRAL: 'Mi',
  DEEPSEEK: 'Ds',
  XAI: 'x',
  SBER: 'S',
  YANDEX: 'Y',
};

export function getProviderColor(provider?: string | null): string {
  if (!provider) return 'bg-gray-500';
  const key = provider.toUpperCase();
  return PROVIDER_COLORS[key] || 'bg-gray-500';
}

export function getProviderLabel(provider?: string | null): string {
  if (!provider) return '?';
  const key = provider.toUpperCase();
  return PROVIDER_LABELS[key] || provider.slice(0, 2).toUpperCase();
}

export function ProviderAvatar({
  provider,
  size = 16,
  className = '',
}: {
  provider?: string | null;
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${getProviderColor(provider)} ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(8, size * 0.42) }}
      title={provider || ''}
    >
      {getProviderLabel(provider)}
    </span>
  );
}

export function ModelAvatar({
  provider,
  size = 16,
}: {
  provider?: string | null;
  size?: number;
}) {
  if (!provider) {
    return (
      <span
        className="inline-flex items-center justify-center rounded-full bg-violet-500 text-white shrink-0"
        style={{ width: size, height: size }}
      >
        <Sparkles size={Math.max(8, size * 0.55)} />
      </span>
    );
  }
  return <ProviderAvatar provider={provider} size={size} />;
}